/**
 * @author sajocmathew
 * @description Reducer for the components in the page where the agent colours are configured
 */
import {
    RESET_ALL,
    SET_AGENT_COLOURS,
    SET_AGENT_COLOUR_THEMES
} from '../actions/action-types';

const initialState = {
    agentColorDetails: null,
    agentColorThemes: []
}

export const agentColourReducer = (state = initialState, action) => {
    switch (action.type) {
        case SET_AGENT_COLOURS:
            return {
                ...state,
                agentColorDetails: action.payload?.Payload || action.payload
            };

        case SET_AGENT_COLOUR_THEMES:
            return {
                ...state,
                agentColorThemes: action.payload?.Payload || action.payload
            };

        case RESET_ALL:
            return {
                ...state,
                agentColorDetails: null,
                agentColorThemes: []
            };

        default:
            return state;
    }
}
  